import { type HttpClient } from '../useHttpClient';

export interface UnitPerformanceScoreResponse {
  myUnitScore: string;
  myUnitPercentile: string;
  companyAvgScore: string;
}

export const fetchUnitPerformanceScore =
  (httpClient: HttpClient) => async (unitId: number) => {
    const response = await httpClient.api(`/admin/kpis/unit/${unitId}/score`, {
      method: 'GET',
    });

    return response.json as UnitPerformanceScoreResponse;
  };

export interface UnitPerformanceDataResponseEntry {
  id: number;
  name: string;
  latestTarget: string | undefined;
  latestActual: string | undefined;
  latestPerformance: string | undefined;
  vsLastEntry: string | undefined;
  latestCreatedOn: string | undefined;
  previousTarget: string | undefined;
  previousActual: string | undefined;
  previousPerformance: string | undefined;
  previousCreatedOn: string | undefined;
}

export const fetchUnitPerformanceData =
  (httpClient: HttpClient) => async (unitId: number) => {
    const response = await httpClient.api(`/admin/kpis/unit/${unitId}/data`, {
      method: 'GET',
    });

    return response.json as UnitPerformanceDataResponseEntry[];
  };

export interface UnitPerformanceInsight {
  id: number;
  createdOn: string;
  publishedOn: string | undefined;
  publishedById: number | undefined;
  content: string | undefined;
  contentVersion: number | undefined;
  contentLanguage: string | undefined;
  contentByUserId: number | undefined;
  contentBy: 'LLM' | 'USER' | null;
}

export interface UnitPerformanceInsightsResponse {
  insights: Partial<UnitPerformanceInsight> & {
    status: 'published' | 'draft' | 'no-data';
  };
  previousInsights: UnitPerformanceInsight[];
}

export const fetchUnitPerformanceInsights =
  (httpClient: HttpClient) => async (unitId: number) => {
    const response = await httpClient.api(
      `/admin/kpis/unit/${unitId}/insights`,
      {
        method: 'GET',
      }
    );

    return response.json as UnitPerformanceInsightsResponse;
  };

export interface UnitPerformanceLlmInsightResponse {
  id: number;
  createdOn: string;
  content: string | undefined;
  contentVersion: number | undefined;
  contentLanguage: string | undefined;
  contentModelId: string | undefined;
  inputUserPromptFiles: string[];
}

export const fetchUnitPerformanceLlmInsights =
  (httpClient: HttpClient) => async (unitId: number) => {
    const response = await httpClient.api(
      `/admin/kpis/unit/${unitId}/insights/llm`,
      {
        method: 'GET',
      }
    );

    return response.json as UnitPerformanceLlmInsightResponse;
  };
